import Joi from 'joi';

// Note: the order of fields in the `Joi` object is the order any errors
// will be displayed on the page.
const createPartnerSchema = Joi.object({
  system_name: Joi.string().label('System Name').required(),
  name: Joi.string().label('Name').required(),
  refersion_id: Joi.string().label('Refersion ID').required(),
  active: Joi.boolean().label('Active').default(false)
});

const updatePartnerSchema = Joi.object({
  partner_id: Joi.string().label('Partner Id').required(),
  system_name: Joi.string().label('System Name').required(),
  name: Joi.string().label('Name').required(),
  refersion_id: Joi.string().label('Refersion ID').required(),
  active: Joi.boolean().label('Active').required()
});

export default {
  createPartnerSchema,
  updatePartnerSchema
};
